// Product Gallery with vanilla JS scroll-snap
document.addEventListener('DOMContentLoaded', function() {
  const galleries = document.querySelectorAll('.gallery-top');

  galleries.forEach(function(gallery) {
    const mainScroller = gallery;
    const thumbContainer = gallery.nextElementSibling;
    if (!thumbContainer) return;

    const thumbScroller = thumbContainer.firstElementChild;
    if (!thumbScroller) return;

    const mainSlides = mainScroller.querySelectorAll('.product-imageslide');
    const thumbSlides = thumbScroller.querySelectorAll('.thumb-slide');

    // Sync thumbnail clicks to main gallery
    thumbSlides.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() {
        if (mainSlides[index]) {
          mainSlides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        updateActiveThumbnail(index);
      });
    });

    // Sync main gallery scroll to thumbnails
    let scrollTimeout;
    mainScroller.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        const scrollLeft = mainScroller.scrollLeft;
        const slideWidth = mainSlides[0]?.offsetWidth || 0;
        const currentIndex = Math.round(scrollLeft / slideWidth);
        updateActiveThumbnail(currentIndex);
        updateProgressBar(currentIndex);
      }, 50);
    });

    function updateActiveThumbnail(index) {
      thumbSlides.forEach(function(thumb, i) {
        if (i === index) {
          thumb.classList.add('active');
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          thumb.classList.remove('active');
        }
      });
    }

    function updateProgressBar(index) {
      const progressBar = mainScroller.querySelector('.swiper-pagination-progressbar-fill');
      if (progressBar && mainSlides.length > 0) {
        const progress = ((index + 1) / mainSlides.length) * 100;
        progressBar.style.transform = 'scaleX(' + (progress / 100) + ')';
      }
    }

    // Navigation arrows
    const navContainer = mainScroller.querySelector('.product-slider-controls');
    if (navContainer) {
      const nextBtn = navContainer.querySelector('.swiper-button-next');
      const prevBtn = navContainer.querySelector('.swiper-button-prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          const scrollLeft = mainScroller.scrollLeft;
          const slideWidth = mainSlides[0]?.offsetWidth || 0;
          mainScroller.scrollBy({ left: slideWidth, behavior: 'smooth' });
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          const scrollLeft = mainScroller.scrollLeft;
          const slideWidth = mainSlides[0]?.offsetWidth || 0;
          mainScroller.scrollBy({ left: -slideWidth, behavior: 'smooth' });
        });
      }
    }

    // Initialize first thumbnail as active
    updateActiveThumbnail(0);
    updateProgressBar(0);
  });
});

// Product image zoom using native dialog
document.addEventListener('DOMContentLoaded', function() {
  const zoomLinks = document.querySelectorAll('.js-zoom-gallery');

  if (zoomLinks.length === 0) return;

  // Create zoom dialog
  const zoomDialog = document.createElement('dialog');
  zoomDialog.className = 'product-zoom-dialog';
  zoomDialog.innerHTML = `
    <div class="zoom-dialog-content">
      <button class="zoom-close" aria-label="Close">&times;</button>
      <button class="zoom-prev" aria-label="Previous">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
      </button>
      <button class="zoom-next" aria-label="Next">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
      </button>
      <img class="zoom-image" src="" alt="">
    </div>
  `;
  document.body.appendChild(zoomDialog);

  const zoomImage = zoomDialog.querySelector('.zoom-image');
  const closeBtn = zoomDialog.querySelector('.zoom-close');
  const prevBtn = zoomDialog.querySelector('.zoom-prev');
  const nextBtn = zoomDialog.querySelector('.zoom-next');

  let currentIndex = 0;
  const images = Array.from(zoomLinks).map(function(link) {
    return link.getAttribute('href');
  });

  function showImage(index) {
    currentIndex = index;
    zoomImage.src = images[index];

    // Show/hide nav buttons
    prevBtn.style.display = index > 0 ? 'flex' : 'none';
    nextBtn.style.display = index < images.length - 1 ? 'flex' : 'none';
  }

  zoomLinks.forEach(function(link, index) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      showImage(index);
      zoomDialog.showModal();
    });
  });

  closeBtn.addEventListener('click', function() {
    zoomDialog.close();
  });

  prevBtn.addEventListener('click', function() {
    if (currentIndex > 0) {
      showImage(currentIndex - 1);
    }
  });

  nextBtn.addEventListener('click', function() {
    if (currentIndex < images.length - 1) {
      showImage(currentIndex + 1);
    }
  });

  // Close on backdrop click
  zoomDialog.addEventListener('click', function(e) {
    if (e.target === zoomDialog) {
      zoomDialog.close();
    }
  });

  // Keyboard navigation
  zoomDialog.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft' && currentIndex > 0) {
      showImage(currentIndex - 1);
    } else if (e.key === 'ArrowRight' && currentIndex < images.length - 1) {
      showImage(currentIndex + 1);
    }
  });
});

/*********Subscriptions variant js for subify**********/

const subscriptionOptions = document.querySelectorAll('.option-grid-Subscriptions .js-radio-variant');

if (subscriptionOptions.length > 0) {
    subscriptionOptions.forEach(option => {

        option.addEventListener('click', function(event) {
            const selectedValue = event.target.value;
            const sellingPlanBoxes = document.querySelectorAll('.subify-selling-plan-option-box');

            sellingPlanBoxes.forEach(box => {
                const planLabel = box.querySelector('.subify-selling-plan-label').textContent;

                if (planLabel.includes(selectedValue)) {
                    setTimeout(() => {
                        box.click();
                    }, 300);
                }
            });
        });
        setTimeout(() => {
          if(option.checked){
            option.click();
          }
        },2000)


    });
}


if(document.querySelectorAll('#isagift').length > 0){
  var giftEmailInput = document.getElementById('gift-email');
  giftEmailInput.addEventListener('input', function() {
    validateGiftEmail();
  });

  function validateGiftEmail() {
    var giftEmail = giftEmailInput.value;
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (giftEmail.trim() === '') {
      document.querySelector('.product-form__buttons .product-form__submit').disabled = false;
      giftEmailInput.classList.remove('error')
    } else {
      if (!emailRegex.test(giftEmail)) {
        document.querySelector('.product-form__buttons .product-form__submit').disabled = true;
        giftEmailInput.classList.add('error')
      } else {
        document.querySelector('.product-form__buttons .product-form__submit').disabled = false;
        giftEmailInput.classList.remove('error')
      }
    }
  }
  document.querySelector('#isagift').addEventListener('change', function() {
    giftEmailInput.value = '';
    validateGiftEmail();
  })
}
